
import { Base } from '../base-component';

import './header.component.scss';

import { MediaQueryService } from '../../services/media-query.service';

import * as $ from 'jquery';

export class Header extends Base {

	header: Element;
	accountMenu: JQuery<HTMLElement>; //.header__secondary-bar-login
	accountDesktopMenu: JQuery<HTMLElement>; //.header__mega-menu--account
	accountMobileMenu: JQuery<HTMLElement>; //.header__mobile-menu-user
	hamburger: JQuery<HTMLElement>; //.js-hamburger
    mobileMenu: JQuery<HTMLElement>; //.header__mobile-menu
    megaNavTab: JQuery<HTMLElement>; //.header__mega-menu-nav-item
	mobileAccountMenu: JQuery<HTMLElement>; //.header__mobile-menu-account
	mobileMenuNav: JQuery<HTMLElement>; //.header__mobile-menu-nav
	mobileMenuNavItem: JQuery<HTMLElement>; //.header__mobile-menu-nav-item
	mobileMenuNavSecondaryItem: JQuery<HTMLElement>; //.header__mobile-menu-nav-secondary-item
    mobileMenuNavTertiaryItem: JQuery<HTMLElement>; //.header__mobile-menu-nav-tertiary-item
	mobileMenuNavTertiaryBack: JQuery<HTMLElement>; //.header__mobile-menu-nav-tertiary-back

	lastScrollTop: number;
	open: boolean = false;
	accountOpen: boolean = false;
	activeItem: string = '';
	activeSecondaryItem: string = '';
	activeTertiaryItem: string = '';
	expanded: boolean = false;

	// group
	groupCountryInitContainer: any;
	groupCountryTrigger: any;
	groupCountryContainer: any;
	groupCountrySelected: any;
	groupCountryWebsite: any;
	groupCountryCollapse: any;
	groupCountryInitContainerNotSelected: any;
	groupCountryInitContainerSelected: any;
	groupCountryContainerLink: any;

	// language
	mobileMenuNavLanguageSelector: any;
	mobileMenuNavLanguageOverlay: any;

	constructor(element: Element){

		super(element);
		this.header = element;				
	}

	init(){
		this.accountMenu = $('.header__secondary-bar-login');
		this.accountMobileMenu = $('.header__mobile-menu-user');
		this.accountDesktopMenu = $('.header__mobile-menu-user');
		this.hamburger = $('.js-hamburger');
        this.mobileMenu = $('.header__mobile-menu');
        this.megaNavTab = $('.header__mega-menu-nav-item');
		this.mobileAccountMenu = $('.header__mobile-menu-account');
		this.mobileMenuNav = $('.header__mobile-menu-nav');
		this.mobileMenuNavItem = $('.header__mobile-menu-nav-item');
		this.mobileMenuNavSecondaryItem = $('.header__mobile-menu-nav-secondary-item');
        this.mobileMenuNavTertiaryItem = $('.header__mobile-menu-nav-tertiary-item');
        this.mobileMenuNavTertiaryBack = $('.header__mobile-menu-nav-tertiary-back');
		
		let countrySelector = $('.country-selector').detach();
		$('.header').append(countrySelector);

		this.accountOpen = false;

		// group
		this.groupCountryInitContainer = Array.from(this.element.querySelectorAll('.js-group-country-container-init'));
		this.groupCountryInitContainerNotSelected = Array.from(this.element.querySelectorAll('.js-group-country-container__notselected'));
		this.groupCountryInitContainerSelected = Array.from(this.element.querySelectorAll('.js-group-country-container__selected'));
		this.groupCountryTrigger = Array.from(this.element.querySelectorAll('.js-group-country-select'));
		this.groupCountryContainer = Array.from(this.element.querySelectorAll('.js-group-country-container'));
		this.groupCountrySelected = Array.from(this.element.querySelectorAll('.js-group-country-selected'));
		this.groupCountryWebsite = Array.from(this.element.querySelectorAll('.js-group-country-website'));
		this.groupCountryCollapse = Array.from(this.element.querySelectorAll('.header__mega-menu--account__split--left .js-collapse-trigger'));
		this.groupCountryContainerLink = Array.from(this.element.querySelectorAll('.header__mega-menu--account__split--container-link'));

		// language selector
		if(this.element.querySelector('.js-language-selector-button-mobile')){
			this.mobileMenuNavLanguageSelector = this.element.querySelector('.js-language-selector-button-mobile');
		}
		if(this.element.querySelector('.header__mobile-menu-language__overlay')){
			this.mobileMenuNavLanguageOverlay = this.element.querySelector('.header__mobile-menu-language__overlay');
		}

	}

	bindEvents() {

		$('.js-country-selector-open').click(() => {

            this.lastScrollTop = $(window).scrollTop();

            $('body').css({
				'overflow': 'hidden',
				'position': 'relative',
				'width': '100%'
			});

			$('.country-selector__modal').addClass('country-selector__modal--reveal');
        });
        
        $('.country-selector__close').click(() => {
            
            $('body').css({
				'overflow': '',
				'position': '',
				'width': ''
			});

			$(window).scrollTop(this.lastScrollTop);

		});

		$(window).scroll(() => {

			this.scroll();

		});
	

		this.hamburger.click('click', ()=> {
			
			this.toggleMobileMenu();

			if(this.mobileMenuNavLanguageSelector) {
	
				this.mobileMenuNavLanguageSelector.classList.remove('header__mobile-menu-language__button__opened');
				this.mobileMenuNavLanguageOverlay.classList.remove('header__mobile-menu-language__overlay--opened');
	
			}

		});

		this.accountMenu.click('click', ()=> {
			this.toggleAccountMobileMenu();
		});
		
		this.accountMobileMenu.click('click', ()=> {
			this.toggleAccountMobileMenu();
		});
        
        this.megaNavTab.click('click', (event)=> {
			
			let megaNav = $(event.currentTarget).closest('.header__mega-menu');
            let section = $(event.currentTarget).data('section');            
            $(megaNav).find('.header__mega-menu-nav-item').removeClass('header__mega-menu-nav-item--active');
            $(megaNav).find('.header__mega-menu-nav-content').removeClass('header__mega-menu-nav-content--active');
            $(event.currentTarget).addClass('header__mega-menu-nav-item--active');
			$(megaNav).find(".header__mega-menu-nav-content[data-section='" + section + "']").addClass('header__mega-menu-nav-content--active');
			
		});

		this.mobileMenuNavItem.click('click', (event)=> {
			
			let section = $(event.currentTarget).data('accordion');

			if(this.activeItem == section){
				this.activeItem = '';
				$(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-secondary--open');
				this.mobileMenuNavItem.removeClass('header__mobile-menu-nav-item--open');
			} else {
				this.activeItem = section;
				this.mobileMenuNavItem.removeClass('header__mobile-menu-nav-item--open');
				$(event.currentTarget).addClass('header__mobile-menu-nav-item--open');
				$(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-secondary--open');
				$(".header__mobile-menu-nav-secondary[data-accordion='" + this.activeItem + "']").addClass('header__mobile-menu-nav-secondary--open');

            }
            
		});

		this.mobileMenuNavSecondaryItem.click('click', (event)=> {

			let section = $(event.currentTarget).data('accordion');

			if ($(event.currentTarget).hasClass('header__mobile-menu-nav-secondary-item--expanded')) {
				$(".header__mobile-menu-nav-item").removeClass('header__mobile-menu-nav-item--hide');
				$(event.currentTarget).removeClass('header__mobile-menu-nav-secondary-item--expanded');

				$(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary-item--activemenu');
				this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
				$(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
			}

			if(this.activeSecondaryItem == section){
				this.activeSecondaryItem = '';
				$(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-tertiary--open');
				this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--open');
				$(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
			} else {
				this.activeSecondaryItem = section;
				this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--open');
				$(event.currentTarget).addClass('header__mobile-menu-nav-secondary-item--open');
				$(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
                $(".header__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "']").addClass('header__mobile-menu-nav-tertiary--open');
                //$(".header__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header__mobile-menu-nav-tertiary-item").first().addClass('header__mobile-menu-nav-tertiary-item--open');
                //$(".header__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header__mobile-menu-nav-quaternary").first().addClass('header__mobile-menu-nav-quaternary--open');				
				//$(".header__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header__mobile-menu-nav-tertiary-item").first().click();				
				$(".header__mobile-menu__content").addClass('header__mobile-menu__content--expanded');
            }
            
		});

		this.mobileMenuNavTertiaryItem.click('click', (event)=> {
			event.stopImmediatePropagation();
			let section = $(event.currentTarget).data('accordion');	

			$(".header__mobile-menu-nav-item").addClass('header__mobile-menu-nav-item--hide');
			// $(".header__mobile-menu-top").hide();
			
			if(this.activeTertiaryItem == section){
				this.activeTertiaryItem = '';
				$(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary-item--activemenu');
				this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
				$(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
			} else {
				this.activeTertiaryItem = section;
				this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
				$(".header__mobile-menu-nav-tertiary").addClass('header__mobile-menu-nav-tertiary-item--activemenu');
				$(event.currentTarget).addClass('header__mobile-menu-nav-tertiary-item--open');
				$('.header__mobile-menu-nav-secondary-item--open').addClass('header__mobile-menu-nav-secondary-item--expanded');	
				$(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
				$(".header__mobile-menu-nav-quaternary[data-accordion='" + this.activeTertiaryItem + "']").addClass('header__mobile-menu-nav-quaternary--open');

            }
            
        });
        
        this.mobileMenuNavTertiaryBack.click('click', (event)=> {
			event.stopImmediatePropagation();
            event.preventDefault();
			this.activeSecondaryItem = '';
			this.activeTertiaryItem = '';

			// $(".header__mobile-menu-top").show();

			$(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded');
			$(".header__mobile-menu-nav-item").removeClass('header__mobile-menu-nav-item--hide');
			
			$(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-tertiary--open');
			this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--open');
			this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--expanded');
			$(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
                
            $(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
			this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
            $(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
		});

		// group
		if(this.groupCountryTrigger){

			this.groupCountryTrigger.map((item) => item.addEventListener('click', (event)=> {

				// change styling if country is selected
				this.groupCountryInitContainer.map((container: any) => {
					this.accountOpen = false;
					container.classList.remove('header__mega-menu--account__split--white');
					container.classList.add('header__mega-menu--account__split');
				});
				this.groupCountryInitContainerNotSelected.map((container: any) => {
					container.classList.add('d-none');
				});
				this.groupCountryInitContainerSelected.map((container: any) => {
					container.classList.remove('d-none');
				});

				// selected element
				let element: any;
				if(event.currentTarget) {
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				let getCountry = element.getAttribute('data-country');
				let getCountryUrl = element.getAttribute('data-link');
				let getHTML = element.outerHTML;
				getHTML = getHTML.replace('header__mega-menu--account__split--countries', 'header__mobile-menu-account__split--country-selected');

				// change website link
				this.groupCountryWebsite.map((link: any) => {
					link.setAttribute('href', getCountryUrl);
				});

				// get element html
				this.groupCountrySelected.map((container: any) => {
					container.innerHTML = getHTML;
				});

				// show relevant container
				this.groupCountryContainer.map((container: any)=> {
					container.classList.add('d-none');
					let getCountryContainer = container.getAttribute('data-country');
					if(getCountryContainer === getCountry){
						container.classList.remove('d-none');
					}
				});

				// remove relevant button once selected
				this.groupCountryTrigger.map((trigger: any)=> {
					let closestContainer = trigger.closest('div');
					let getCountryContainer = trigger.getAttribute('data-country');
					// if(closestContainer){
					// 	if(getCountryContainer === getCountry){
					// 		closestContainer.classList.add('d-none');
					// 	}else{
					// 		closestContainer.classList.remove('d-none');
					// 	}
					// }
				});

				// collapse countries
				if(!element.classList.contains('js-initial-load')) {
					this.groupCountryCollapse.map((trigger: any)=> {
						trigger.click();
					});
				}

				this.groupCountryContainerLink.map((item)=>{

					let newComponent = document.createElement('div');
					newComponent.classList.add('header__animate-new-country');
					item.appendChild(newComponent);

					setTimeout(() => {
						$('div.header__animate-new-country').remove();
					}, 600);

				})


			}))

		}

		if(this.mobileMenuNavLanguageSelector) {

			this.mobileMenuNavLanguageSelector.addEventListener('click', (event)=>{

				if(this.mobileMenuNavLanguageSelector.classList.contains('header__mobile-menu-language__button__opened')) {

					this.mobileMenuNavLanguageSelector.classList.remove('header__mobile-menu-language__button__opened');
					this.mobileMenuNavLanguageOverlay.classList.remove('header__mobile-menu-language__overlay--opened');

				}else {

					this.mobileMenuNavLanguageSelector.classList.add('header__mobile-menu-language__button__opened');
					this.mobileMenuNavLanguageOverlay.classList.add('header__mobile-menu-language__overlay--opened');

				}

			});

		}

	}
	
	scroll() {
		
		if ($(window).scrollTop() > 20) {

			$('.header').addClass("header--sticky");

		}
		else {

			$('.header').removeClass("header--sticky");

		}

	}
    
	toggleMobileMenu() {

		this.open = !this.open;
		this.expanded = false;

		this.activeItem = '';
		this.activeSecondaryItem = '';
		this.activeTertiaryItem = '';

		this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");

		if (this.open) {

			this.lastScrollTop = $(window).scrollTop();

			$('body').css({
				'overflow': 'hidden',
				'position': 'relative',
				'width': '100%'
			});

			document.getElementsByClassName('main')[0].addEventListener("touchmove", this.freezeVp, false);


			if (this.accountOpen) {
				this.toggleAccountMobileMenu();
			}

			this.hamburger.addClass("header__hamburger--open");
			$(this.element).addClass('header--open');
			this.mobileMenu.addClass("header__mobile-menu--open");
			this.mobileMenuNav.addClass("header__mobile-menu-nav--open");

		}else{
			$('body').css({
				'overflow': '',
				'position': '',
				'width': ''
			});

			$(window).scrollTop(this.lastScrollTop);

			document.getElementsByClassName('main')[0].removeEventListener("touchmove", this.freezeVp, false);

			$(this.element).removeClass('header--open');
			this.hamburger.removeClass("header__hamburger--open");
			this.mobileMenu.removeClass("header__mobile-menu--open");
			this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
        }
        
	}

	freezeVp (e) {
		e.preventDefault();
	};

	toggleAccountMobileMenu(){

		if (MediaQueryService.getMediaQuery() === 'x-small') {

			$('.header__mobile-menu__content').scrollTop(0);

			this.accountOpen = !this.accountOpen;

			if (this.accountOpen) {

				$(".header__mobile-menu__content").addClass('header__mobile-menu__content--expanded');

				this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
				this.mobileAccountMenu.addClass("header__mobile-menu-account--open");

			} else {

				$(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded');

				this.mobileMenuNav.addClass("header__mobile-menu-nav--open");
				this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");

	        }

		} else if (MediaQueryService.getMediaQuery() === 'medium-small' || MediaQueryService.getMediaQuery() === 'small') {

			$('.header__mega-menu--account').scrollTop(0);

			this.accountOpen = !this.accountOpen;

			if (this.accountOpen) {
				$(".header__mega-menu--account").addClass('header__mega-menu--open');
			} else {
				$(".header__mega-menu--account").removeClass('header__mega-menu--open');
	        }

		}

	}

	closeMobileMenu(){

		this.open = false;
		this.activeItem = '';
		this.activeSecondaryItem = '';
		this.activeTertiaryItem = '';
		this.expanded = false;

		this.hamburger.removeClass("header__hamburger--open");
		this.mobileMenu.removeClass("header__mobile-menu--open");
        this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
        
	}
	
}



// WEBPACK FOOTER //
// ./components/header/header.component.ts